<script setup>
  const props = defineProps({
    row: {
      default: 10,
      type: Number
    },
    cols: {
      default: 30,
      type: Number
    },
    placeholder: {
      default: 'Message',
      type: String
    },
    textareaValue: {
      default: null,
      type: String
    }
  })
  defineEmits(['update:textareaValue'])
</script>

<template>
  <textarea
    id=""
    name=""
    :cols="props.cols"
    :rows="props.row"
    class="shadow px-3 py-2 rounded-md placeholder:text-xs placeholder-gray-300 w-full"
    :placeholder="props.placeholder"
    @input="$emit('update:textareaValue', $event.target.value)"
  />
</template>

<style scoped>

</style>
